import { Card, Space, Typography } from 'antd';
import { PictureOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export const EmptyState = ({ type = 'select' }) => {
    const stateConfig = {
        select: {
            icon: <PictureOutlined style={{ fontSize: '48px', color: '#d9d9d9' }} />,
            title: 'Selecciona un Pokémon',
            description: 'Elige un Pokémon de la lista para ver y editar su información'
        },
        loading: {
            icon: null,
            title: 'Cargando información del Pokémon...',
            description: null
        },
        noData: {
            icon: null,
            title: 'No se encontraron datos del Pokémon',
            description: null
        }
    };

    const config = stateConfig[type];

    return (
        <Card
            style={{
                textAlign: 'center',
                padding: '60px 20px',
                borderRadius: '12px',
                border: type === 'select' ? '2px dashed #d9d9d9' : '1px solid #f0f0f0',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                background: type === 'select' ? '#fafafa' : '#ffffff'
            }}
        >
            <Space direction="vertical" size="large">
                {config.icon}
                <div>
                    <Title level={4} style={{ color: '#8c8c8c' }}>
                        {config.title}
                    </Title>
                    {config.description && (
                        <Text style={{ color: '#8c8c8c' }}>
                            {config.description}
                        </Text>
                    )}
                </div>
            </Space>
        </Card>
    );
};
